import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  REAL_ESTATE_DOMAIN_INTRO,
  REAL_ESTATE_GROUPS,
  REAL_ESTATE_USE_CASES_SEO,
  REAL_ESTATE_DOMAIN_FAQS,
  REAL_ESTATE_ITEM_LIST_JSONLD,
  REAL_ESTATE_BREADCRUMB_JSONLD,
  REAL_ESTATE_WEBPAGE_JSONLD,
  REAL_ESTATE_FAQ_JSONLD,
} from "../../data/rpa/real-estate-construction-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = REAL_ESTATE_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function RealEstateRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? REAL_ESTATE_GROUPS
      : REAL_ESTATE_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={REAL_ESTATE_DOMAIN_INTRO}
        domainSlug="real-estate-construction-domain"
        basePath="/rpa-use-cases"
        useCaseCount={REAL_ESTATE_USE_CASES_SEO.length}
        groupCount={REAL_ESTATE_GROUPS.length}
        itemListJsonLd={REAL_ESTATE_ITEM_LIST_JSONLD}
        faqJsonLd={REAL_ESTATE_FAQ_JSONLD}
        breadcrumbJsonLd={REAL_ESTATE_BREADCRUMB_JSONLD}
        webPageJsonLd={REAL_ESTATE_WEBPAGE_JSONLD}
        keywords="Real Estate & Construction automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{REAL_ESTATE_DOMAIN_INTRO.title}</h1>
          {REAL_ESTATE_DOMAIN_INTRO.content ? <p>{REAL_ESTATE_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={REAL_ESTATE_USE_CASES_SEO}
        groups={REAL_ESTATE_GROUPS}
        heading="Real Estate & Construction Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={REAL_ESTATE_DOMAIN_INTRO.title}
        domainFaqs={REAL_ESTATE_DOMAIN_FAQS}
        useCases={REAL_ESTATE_USE_CASES_SEO}
      />
    </div>
  );
}

